<template>
  <v-row no-gutters>
    <layer-style-single-wrapper
      :items="singleStyleItems"
      :is-style-valid.sync="isStyleValidComputed"
    >
      <template v-for="(item, key) of singleStyleItems" #[item.key]>
        <component :is="item.component" v-bind="item" :key="key" v-model="singleStyle[item.key]" />
      </template>
    </layer-style-single-wrapper>
  </v-row>
</template>
<script>
import { VTextField } from 'vuetify/lib';
export default {
  components: {
    ColorField: () => import('@/components/fields/ColorField'),
    LayerStyleSingleWrapper: () => import('@/components/settings/LayerStyleSingleWrapper'),
    SliderField: () => import('@/components/fields/SliderField'),
    VTextField
  },
  props: {
    geometryType: {
      type: String,
      default: () => {
        return 'point';
      }
    },
    isStyleValid: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    singleStyle: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  computed: {
    isStyleValidComputed: {
      get() {
        return this.isStyleValid;
      },
      set(nV) {
        this.$emit('update:isStyleValid', nV);
      }
    },
    singleStyleItems() {
      const items = [
        {
          component: 'ColorField',
          key: 'strokeColor',
          label: this.$i18n.t('settings.layersList.strokeColor')
        },
        {
          component: 'VTextField',
          key: 'strokeWidth',
          label: this.$i18n.t(
            this.geometryType === 'point' ? 'settings.layersList.pointSize' : 'settings.layersList.strokeWidth'
          ),
          outlined: true,
          type: 'number',
          min: '0',
          step: '0.5',
          max: '10',
          rules: [
            value => !!value || this.$i18n.t('default.requiredField'),
            value => value >= 0 || this.$i18n.t('default.incorrectValue'),
            value => value <= 10 || this.$i18n.t('default.incorrectValue')
          ]
        },
        {
          component: 'SliderField',
          key: 'opacity',
          label: this.$i18n.t('settings.layersList.opacity'),
          step: '1',
          min: '0',
          max: '100',
          rules: [
            value => !!value || value == '0' || this.$i18n.t('default.requiredField'),
            value => value >= 0 || this.$i18n.t('default.incorrectValue'),
            value => value <= 100 || this.$i18n.t('default.incorrectValue')
          ]
        }
      ];
      if (this.geometryType !== 'line') {
        items.unshift({
          component: 'ColorField',
          key: 'fillColor',
          label: this.$i18n.t('settings.layersList.fillColor')
        });
      }
      return items;
    }
  }
};
</script>